export default __webpack_public_path__ + "static/media/Humility.1c56c45e.svg";